<template>
  <section>
    <div class>
      <div class="utab clearfix">
        <ul class="clearlist clearfix fl">
          <li :class="nowStatus==''?'active':''" @click="changeTab('')">
            <a href="javascript:;">所有订单</a>
          </li>
          <li :class="nowStatus=='0'?'active':''" @click="changeTab('0')">
            <a href="javascript:;">待付款</a>
          </li>
          <li :class="nowStatus==1?'active':''" @click="changeTab('1')">
            <a href="javascript:;">待发货</a>
          </li>
          <li :class="nowStatus==2?'active':''" @click="changeTab('2')">
            <a href="javascript:;">待收货</a>
          </li>
          <li :class="nowStatus==3?'active':''" @click="changeTab('3')">
            <a href="javascript:;">已完成</a>
          </li>
        </ul>
        <div class="usearch fr">
          <!-- <el-button
            round
            type="primary"
            size="small"
            class="exportantOrder"
            @click="exportantOrder">
            导出订单
          </el-button>-->
          <input type="text" placeholder="商品名称/订单号" class="layui-input" v-model="keyword" />
          <button type="primary" @click="search" class="layui-btn layui-btn-sm">搜索</button>
        </div>
      </div>
      <el-table
        :span-method="arraySpanMethod"
        :data="allOrder.data"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
        style="width:98%; margin: 20px auto"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="订单信息" width="100">
          <template slot-scope="scope">
            <div class="text_l">
              <div>{{ scope.row.orderno }}</div>
              <br />
              <div>{{ scope.row.addtime }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="商品金额" width="80"></el-table-column>
        <el-table-column prop="shipfee" label="运费" width="60"></el-table-column>
        <el-table-column prop="discount" label="优惠" width="60"></el-table-column>
        <el-table-column prop="amount" label="实付款" width="80"></el-table-column>
        <el-table-column label="商品信息" width="260" class-name="tablegoodsinfo">
          <template slot-scope="scope">
            <div class="hebin" v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                    <img :src="item_i.indexpic" />
                  </a>
                </div>
                <div class="cont flex">
                  <div class style="width:144px">
                    <div class="name ellipsis-2">{{item_i.title}}</div>
                    <div class="info">{{item_i.specnames}}</div>
                    <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
                  </div>
                  <div class="color-primary" style="width:50px;text-align:right">{{item_i.unit}}</div>
                  <div class="color-primary" style="width:60px;text-align:right">{{item_i.price}}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单位" width="50"></el-table-column>
        <el-table-column label="单价" width="70"></el-table-column>
        <el-table-column prop="statusText" label="状态" width="80"></el-table-column>
        <el-table-column prop="remark" label="备注" width="80"></el-table-column>
        <el-table-column prop="amount3" label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="primary"
              size="small"
              class="mb10"
              @click="orderdetail(scope.row.orderno)"
            >订单详情</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==2"
              type="primary"
              class="mb10"
              @click="confirmGoods(scope.row.orderno)"
            >确认收货</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==3 && scope.row.iscomment"
              type="primary"
              class="mb10 pingjiabyn"
            >
              <a :href="'#/add_pinjia?orderno='+scope.row.orderno">立即评价</a>
            </el-button>

            <el-button
              size="small"
              v-if="scope.row.expressno"
              type="primary"
              class="mb10"
              @click="logistics(scope.row.expressno)"
            >查看物流</el-button>
            <el-button
              size="small"
              v-if="scope.row.status==0"
              type="primary"
              class="mb10 iconfont"
              @click="goPay(scope.row.orderno,1)"
            >立即支付</el-button>

            <el-button
              size="small"
              v-if="scope.row.status==0"
              type="primary"
              class="mb10"
              @click="closeOrder(scope.row.orderno)"
            >取消订单</el-button>-->
            <el-button
              size="small"
              type="danger"
              class="iconfont"
              @click="deteleOrder(scope.row.id)"
            >恢复订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex ju-ar">
        <el-button
          size="small"
          type="danger"
          class="iconfont"
          @click="selectedAll"
          style="margin:0 10px"
        >
          <span v-if="multipleSelection.length<allOrder.data.length">全选</span>
          <span v-else>全不选</span>
        </el-button>
        <el-button
          size="small"
          type="danger"
          class="iconfont"
          @click="deteleOrder()"
          :disabled="multipleSelection.length==0"
          style="margin:0 10px"
        >恢复所选订单</el-button>
        <el-pagination
          class="fenye"
          @size-change="handleSizeChange"
          @current-change="currentorder"
          :current-page="allOrder.current_page"
          :page-sizes="[5, 10, 20, 50,100]"
          :page-size="allOrder.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allOrder.total"
        ></el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Order",
  data() {
    return {
      userInfo: {},
      guid: sessionStorage.guid,
      indexData: {},
      nowStatus: "",
      keyword: "",
      multipleSelection: [],
      orderstatus: [
        { 0: "待付款" },
        { 1: "待发货" },
        { 2: "待收货" },
        { 3: "已完成" },
        { 4: "已取消" },
        { 5: "已退款" }
      ],
      page: 1,
      pagesize: 5,
       allOrder: {data:[]}, //全部订单的数据
      orderno: "",
      goodsKeyWord: ""
    };
  },
  props: {
    now_status: {
      type: String,
      default: ""
    },
    levelid: {
      type: [String, Number]
    }
  },
  watch: {
    orderno(newValue, oldValue) {
      console.log("fskjfbvuidfbvuikji", newValue);
      // eventBus.$emit("my-event", newValue);
      eventBus.$emit("my-event", {
        orderno: newValue,
        order: true
      });
    }
  },
  methods: {
    currentorder(e) {
      this.page = e;
      this.getOrderList();
    },
    handleSizeChange(e) {
      console.log(e);
      this.pagesize = e;
      this.page = 1;
      this.getOrderList();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex);
      // if (rowIndex % 2 === 0) {
      if (columnIndex === 6) {
        return [1, 3];
      } else if (columnIndex === 7) {
        return [0, 0];
      } else if (columnIndex === 8) {
        return [0, 0];
      }
      //  else if (columnIndex === 1) {
      //   return [0, 0];
      // }
      // }
    },
    // 封装获取数据的方法
    async getOrderList() {
      // alert(this.now_status)
      let res = await this.$fetch("Member/orderlist", {
        body: {
          page: this.page,
          pagesize: this.pagesize,
          status: this.nowStatus,
          keyword: this.keyword,
          isdelete: 1
        }
      });
      for (let i = 0; i < res.data.length; i++) {
        let text = "";
        if (res.data[i].status == 0) {
          text = "待付款";
        } else if (res.data[i].status == 1) {
          text = "待发货";
        } else if (res.data[i].status == 2) {
          text = "待收货";
        } else if (res.data[i].status == 3) {
          text = "已完成";
        } else if (res.data[i].status == 4) {
          text = "已取消";
        } else if (res.data[i].status == 5) {
          text = "已退款";
        }
        res.data[i]["statusText"] = text;
        for (let j = 0; j < res.data[i].detail.length; j++) {
          if (res.data[i].detail[j].iscomment == 0) {
            res.data[i]["iscomment"] = true;
            break;
          }
        }
      }
      res.per_page = parseInt(res.per_page);
      this.allOrder = res;
    },
    async deteleOrder(ids) {
      this.$confirm("此操作将把订单移出回收站, 是否继续?", "提示", {
        type: "warning"
      })
        .then(async () => {
          if (!ids) {
            ids = this.multipleSelection.map(item => {
              return item.id;
            });

            ids = ids.join(",");
          }
          console.log("this.multipleSelection", ids);
          let res = await this.$fetch("member/removeorder", {
            body: { ids, orderno: "orderno" }
          });
          if (res || res == 0) {
            this.$message.success("恢复成功");
            this.getOrderList();
          }
        })
        .catch(error => {
          console.log(error);
          this.$message({
            type: "info",
            message: "已取消恢复"
          });
        });
    },
    currentPageorder(e) {
      this.page = e;
      this.getOrderList();
    },
    orderdetail(orderno) {
      this.orderno = orderno;
    },

    // 去支付
    goPay(orderno, paymethod) {
      this.$router.push({
        path: `/jieguo?orderno=${orderno}&paymethod=${paymethod}`
      });
    },
    // 取消订单
    async closeOrder(orderno) {
      let res = await this.$fetch("member/cancelorder", {
        body: { guid: this.guid, orderno }
      });
      if (res) {
        layer.alert("操作成功", { icon: 1 });
        this.getOrderList();
      }
    },

    // 确认收货
    async confirmGoods(orderno) {
      // let res = ajaxMethod("confirmGoods", { guid: this.guid, orderno });
      let res = await this.$fetch("member/confirmorder", {
        body: { guid: this.guid, orderno }
      });
      if (res) {
        layer.alert("操作成功", { icon: 1 });
        this.getOrderList();
      }
    },
    // 搜索
    search() {
      this.getOrderList();
    },
    // 改变tab
    changeTab(type) {
      console.log(type);
      this.nowStatus = type;
      console.log(this.now_status);
      this.getOrderList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 查看物流
    logistics(logistics) {
      console.log(logistics);
      layer.open({
        type: 2,
        title: "查看物流",
        shadeClose: true,
        shade: 0.8,
        area: ["400px", "90%"],
        content: `http://m.kuaidi100.com/index_all.html?type=&postid=${logistics}` //iframe的url
      });
    },
    // 全选和全部不选
    selectedAll() {
      if (this.multipleSelection.length < this.allOrder.data.length) {
        this.allOrder.data.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async exportantOrder() {
      if (this.allOrder.data.length == 0) {
        this.$message.error("当前状态下无订单数据");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let token = md5("jrsc");
      let guid = sessionStorage.guid;
      let base =
        sessionStorage.baseUrl +
        "app/member/orderlist?" +
        `token=${token}` +
        `&guid=${guid}` +
        `&page=${this.page}&export=1&pagesize=${this.pagesize}&status=${this.nowStatus}&keyword=${this.keyword}`;
      location.href = base;
      loading.close();
    }
  },
  async mounted() {
    this.nowStatus = this.now_status;
    await this.getOrderList();
    // this.fenye();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang='scss' scoped>
.exportantOrder {
  margin-right: 30px;
}
.img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.cont {
  // width: 150px;
  margin: 0 10px;
}
.cart-price {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/recycleBin.vue